import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 41/41;
const HEIGHT = 43/41;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 41 43" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="file-single-comments" transform="translate(-1095.000000, -326.000000)" fill={color}>
                <g id="Group-7" transform="translate(950.000000, 59.000000)">
                    <g id="Group-6" transform="translate(67.000000, 267.000000)">
                        <g id="Group-47" transform="translate(78.000000, 0.000000)">
                            <rect id="Rectangle-8" x="0" y="0" width="41" height="34" rx="8"></rect>
                            <polygon id="Path-4" points="9 34 9 43 21 34"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconChatBubble extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
